import { useState } from "react";
import { uploadProduct } from "../services/productService";

function UploadItem() {
  const [productName, setProductName] = useState("");
  const [description, setDescription] = useState("");
  //const [size, setSize] = useState("");
  const [sizes, setSizes] = useState([
    {
      size:"",
      quantity:0
    }
  ])
  const [category, setCategory] = useState("");
  const [price, setPrice] = useState("");
  const [quantity, setQuantity] = useState(0);

  const [mainImage, setMainImage] = useState(null);
  const [subImages, setSubImages] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleMainImageChange = (e) => {
    setMainImage(e.target.files[0]);
  };

  const handleSubImageChange = (e) => {
    const selectedImages = Array.from(e.target.files);

    if (selectedImages.length + subImages.length > 6) {
      setError("You can upload up to 6 sub-images.");
      return;
    }

    setSubImages((prev) => [...prev, ...selectedImages]);
    setError("");
  };

  const handleSizeChange = (index, field, value) =>{
    const updated = [...sizes]
    updated[index][field] = field === "quantity"
            ? Number(value)
            : value
       setSizes(updated)
  }

  const addSize = () =>{
    setSizes( prev =>[
      ...prev,
      {
        size:"",
        quantity:0
      }
    ])
  }

  const removeSize = (index) =>{
    setSizes(prev => prev.filter((_,i) => i !== index))
  }

  const handleRemoveSubImage = (index) => {
    setSubImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      
      const data = await uploadProduct({
        productName,
        description,
        sizes,
        category,
        price,
        quantity,
        mainImage,
        subImages
      })

      alert("Item uploaded successfully!");

      // Reset form
      setProductName("");
      setDescription("");
      setSizes("");
      setCategory("");
      setPrice("");
      setQuantity(0);
      setMainImage(null);
      setSubImages([]);
    } catch (err) {
      console.error(err);
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h1>Upload New Item</h1>

      <form onSubmit={handleSubmit}>
        <div>
          <label>Product Name</label>
          <input
            type="text"
            value={productName}
            onChange={(e) => setProductName(e.target.value)}
            required
          />
        </div>

        <div>
          <label>Description</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          />
        </div>

       
        <div>
          <h3>Sizes</h3>
          {
            sizes?.map((item,index)=>(
              <div  key={index} style={{ display: "flex", gap: "10px", marginBottom: "10px"}}>
                 
                 <input type="text" placeholder="Size" value={item.size} onChange={(e) => handleSizeChange( index, "size", e.target.value)}/>
                 <input type="number" placeholder="Quantity" value={item.quantity} onChange={(e) => handleSizeChange( index, "quantity", e.target.value ) }/>
                 <button type="button" onClick={() => removeSize(index)}>Remove</button>
              </div>
            ))
          }
          <button type="button" onClick={addSize}>Add Size</button>
        </div>

        <div>
          <label>Category</label>
          <input
            type="text"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            required
          />
        </div>

        <div>
          <label>Price</label>
          <input
            type="text"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            required
          />
        </div>

        <div>
          <label>Quantity</label>
          <input
            type="number"
            value={quantity}
            onChange={(e) => setQuantity(Number(e.target.value))}
            required
          />
        </div>

        <div>
          <label>Main Image</label>
          <input
            type="file"
            accept="image/*"
            onChange={handleMainImageChange}
            required
          />
        </div>

        <div>
          <label>Sub Images (up to 6)</label>

          <input
            type="file"
            multiple
            accept="image/*"
            onChange={handleSubImageChange}
          />

          {error && <p>{error}</p>}

          <ul>
            {subImages.map((image, index) => (
              <li key={index}>
                {image.name}

                <button
                  type="button"
                  onClick={() => handleRemoveSubImage(index)}
                >
                  Remove
                </button>
              </li>
            ))}
          </ul>
        </div>

        <button disabled={loading}>
          {loading ? "Uploading..." : "Upload Item"}
        </button>
      </form>
    </div>
  );
}

export default UploadItem;